import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const OTPTitle = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Box>
      <Typography variant="subtitle1" className={classes.otpTitle}>
        {title}
      </Typography>
      <Typography className={classes.otpContent}>{content}</Typography>
    </Box>
  );
};

OTPTitle.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

OTPTitle.defaultProps = {};

export default OTPTitle;

const useStyles = makeStyles(() => ({
  otpTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: "1.25rem",
    width: "100%",
  },

  otpContent: {
    fontSize: "0.875rem",
    fontWeight: 400,
    marginBottom: 26,
    marginTop: 12,
    width: "100%",
  },
}));
